module.exports = {
    title: "杭州惠合信息_店商营销服务平台_专注传统渠道数字营销",
    description: "惠合科技深耕快消品行业，构建了品牌商、业务代表、门店、消费者的“四端在线”平台，提供开箱扫码 | 生动化陈列 | 到店核销 | 开盖有礼 | 壹元乐享等BC一体化数字营销方案。",
    keywords: "AI图像识别,一物一码,生动化陈列,扫码活动,数字营销,惠合科技"
}